const es = {
	results: {
		mainTitle: 'Resultados generales',
		testHour: 'ahora son las {{hour}} en punto',
		subtitle: {
			generalRisk: 'Nivel de riesgo general de la empresa',
			default:
				'Consulta el detalle los resultados de la evaluación, analiza cada división de la empresa usando los filtros.',
		},
	},
	evaluations: {
		progress: {
			labelDescription:
				'*Centros de trabajo que han alcanzado el porcentaje mínimo de respuestas requerido para cumplir la NOM-035. Consulta la forma de calcular este porcentaje en el apartado 7.1 de la NOM.',
			header: {
				tooltip: {
					heartFeedback: 'Cumple con la NOM-035',
					user: 'Número de respuestas',
					chart: 'Porcentaje',
				},
				responses: 'Respuestas recibidas',
				workCenter: 'Centro de trabajo',
			},
		},
		cards: {
			header: {
				title: 'Guías aplicadas',
			},
		},
	},
};

export default es;
